angular.module("myApp").directive("forceFocus", function forceFocus($timeout) {
  return (_scope, element) => {
    $timeout(() => {
      element[0].focus()
    }, 50)
    // timeout(element[0].focus, 50) nevar, jo tas trigerēs illegal invocation
  }
})
